import BatchInputLog from "./BatchInputLog";
export default BatchInputLog;
